export default {
  name: 'pa',
  el: {
    colorpicker: {
      confirm: 'تایید',
      clear: 'پاکول',
    },
    datepicker: {
      now: 'اوس',
      today: 'نن',
      cancel: 'ردول',
      clear: 'پاکول',
      confirm: 'تایید',
      selectDate: 'نیټه وټاکئ',
      selectTime: 'وخت وټاکئ',
      startDate: 'پیل نیټه',
      startTime: 'د پيل وخت',
      endDate: 'د پای نیټه',
      endTime: 'د پای وخت',
      prevYear: 'تیر کال',
      nextYear: 'راتلونکی کال',
      prevMonth: 'تیره میاشت',
      nextMonth: 'راتلونکې میاشت',
      year: 'کال',
      month1: 'جنوري',
      month2: 'فبروري',
      month3: 'مارچ',
      month4: 'اپریل',
      month5: 'می',
      month6: 'جون',
      month7: 'جولای',
      month8: 'اګست',
      month9: 'سپتمبر',
      month10: 'اکتوبر',
      month11: 'نومبر',
      month12: 'دسمبر',
      // week: 'week',
      weeks: {
        sun: 'یکشنبه',
        mon: 'دوشنبه',
        tue: 'سه​ شنبه',
        wed: 'چهارشنبه',
        thu: 'پنج​شنبه',
        fri: 'جمعه',
        sat: 'شنبه',
      },
      months: {
        jan: 'جنوري',
        feb: 'فبروري',
        mar: 'مارچ',
        apr: 'اپریل',
        may: 'می',
        jun: 'جون',
        jul: 'جولای',
        aug: 'اګست',
        sep: 'سپتمبر',
        oct: 'اکتوبر',
        nov: 'نومبر',
        dec: 'دسمبر',
      },
    },
    select: {
      loading: 'بار کول',
      noMatch: 'هیڅه ونه موندل شول',
      noData: 'هیڅ معلومات نشته',
      placeholder: 'ځای لرونکی',
    },
    cascader: {
      noMatch: 'هیڅه ونه موندل شول',
      loading: 'بار کول',
      placeholder: 'ځای لرونکی',
      noData: 'هیڅ معلومات نشته',
    },
    pagination: {
      goto: 'ورتګ',
      pagesize: '/د پاڼې اندازه',
      total: 'مجموعه {total}',
      pageClassifier: '',
      page: 'Page', // to be translated
      prev: 'Go to previous page', // to be translated
      next: 'Go to next page', // to be translated
      currentPage: 'page {pager}', // to be translated
      prevPages: 'Previous {pager} pages', // to be translated
      nextPages: 'Next {pager} pages', // to be translated
    },
    messagebox: {
      title: 'عنوان',
      confirm: 'تایید',
      cancel: 'لغوه کول',
      error: 'تيروتنه',
    },
    upload: {
      deleteTip: 'د حذف کولو لپاره پاکه تڼۍ فشار کړئ',
      delete: 'ړنګول',
      preview: 'مخکتنه',
      continue: 'ادامه',
    },
    table: {
      emptyText: 'هیڅ معلومات ونه موندل شول',
      confirmFilter: 'تایید',
      resetFilter: 'پاکول',
      clearFilter: 'ټول',
      sumText: 'مجموعه',
    },
    tree: {
      emptyText: 'هیڅ معلومات ونه موندل شول',
    },
    transfer: {
      noMatch: 'هیڅه ونه موندل شول',
      noData: 'هیڅ معلومات نشته',
      titles: ['لیسټ 1', 'لیسټ 2'],
      filterPlaceholder: 'د متن کلیمې دننه کړئ',
      noCheckedFormat: '{total} توکي',
      hasCheckedFormat: '{checked} توکي از {total} توکي ټاکل شوی دي',
    },
    image: {
      error: 'د انځور پورته کولو کې ستونزه',
    },
    pageHeader: {
      title: 'بیرته راتګ',
    },
    popconfirm: {
      confirmButtonText: 'Yes', // to be translated
      cancelButtonText: 'No', // to be translated
    },
  },
}
